"use client";

import { c as _c } from "react/compiler-runtime";
import { SiModelcontextprotocol, SiRaycast } from "@icons-pack/react-simple-icons";
import { IconBookmark, IconBookmarks, IconBrandApple, IconCornerLeftUp, IconExternalLink, IconPuzzle, IconWorld } from "@tabler/icons-react";
import Link from "next/link";
import { useState } from "react";
import { toast } from "sonner";
import { BetaBadge } from "@/components/beta-badge";
import { APPLE_SHORTCUT_ID } from "@domainstack/constants";
import { Button } from "@domainstack/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@domainstack/ui/dialog";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@domainstack/ui/dropdown-menu";

// a little hack to "unsafely" use raw javascript as a link
function hrefScript(element: HTMLAnchorElement | null) {
  if (!element) return;
  element.href = `javascript:(function(){var t=window.open("${process.env.NEXT_PUBLIC_BASE_URL}/"+location.hostname,"_blank");t.focus()})();`;
}
function handleInspectDomainClick(e: React.MouseEvent) {
  e.preventDefault();
  toast.info("Drag the button to your bookmarks bar to use it.", {
    icon: <IconCornerLeftUp className="size-4" />,
    position: "top-center"
  });
}

/**
 * Footer "Integrations" menu and the bookmarklet dialog it opens — the only
 * interactive part of the otherwise server-rendered footer.
 */
export function AppFooterIntegrations() {
  const $ = _c(13);
  const [isBookmarkletsOpen, setIsBookmarkletsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconPuzzle className="size-4 px-[1px] text-muted-foreground" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DropdownMenuTrigger className="inline-flex cursor-pointer items-center gap-1 text-foreground/85 hover:text-foreground/60">{t0}Integrations<BetaBadge className="ml-[1px] px-1.5 py-0 text-[11px] tracking-normal" /></DropdownMenuTrigger>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DropdownMenuItem nativeButton={false} className="px-1.5 py-1 text-[13px]" render={<Link href="/mcp"><SiModelcontextprotocol className="text-muted-foreground" />MCP Server</Link>} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DropdownMenuItem nativeButton={false} className="px-1.5 py-1 text-[13px]" onClick={() => setIsBookmarkletsOpen(true)}><IconBookmarks className="text-muted-foreground" />Bookmarklet</DropdownMenuItem>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconBrandApple className="text-muted-foreground" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DropdownMenuItem nativeButton={false} className="px-1.5 py-1 text-[13px]" render={<a href={`workflow://shortcuts/${APPLE_SHORTCUT_ID}`} data-disable-progress={true}>{t4}Shortcut<IconExternalLink className="ml-auto size-3.5 translate-y-[-1px] text-muted-foreground" /></a>} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SiRaycast className="text-muted-foreground" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DropdownMenu modal={false}>{t1}<DropdownMenuContent align="center" sideOffset={8} className="min-w-44 bg-background ring-0">{t2}{t3}{t5}<DropdownMenuItem nativeButton={false} className="px-1.5 py-1 text-[13px]" render={<span>{t6}Raycast (soon)<IconExternalLink className="ml-auto size-3.5 translate-y-[-1px] text-muted-foreground" /></span>} disabled={true} /></DropdownMenuContent></DropdownMenu>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DialogHeader><DialogTitle className="flex items-center gap-1.5 text-base font-medium tracking-tight"><IconBookmark className="size-4 text-muted-foreground" />Bookmarklet</DialogTitle></DialogHeader>;
    t9 = <p className="text-sm text-muted-foreground">Drag the button below to your bookmarks bar. Then, press it on any site and the report for that domain will open in a new tab, like magic!</p>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <DialogContent className="!max-w-lg">{t8}{t9}<div className="my-2 flex justify-center"><Button size="lg" nativeButton={false} aria-label="Inspect Domain" render={<a ref={hrefScript} href="#"><IconWorld />Inspect Domain</a>} onClick={handleInspectDomainClick} /></div></DialogContent>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== isBookmarkletsOpen) {
    t11 = <>{t7}<Dialog open={isBookmarkletsOpen} onOpenChange={setIsBookmarkletsOpen}>{t10}</Dialog></>;
    $[11] = isBookmarkletsOpen;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
}